import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, getFormValues } from 'redux-form';
import { renderSwitchComponent } from './SwitchPanel';
import getLocaleMessages from '../../utils/localesMessages';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';

const { recurringRadio = {} } = getLocaleMessages('buttonsV3/switches');

const RecurringSwitch = ({ formValues }) => {
  return (
    <Field
      id="recurringEnabled"
      name="recurringEnabled"
      label="recurringEnabled"
      title={recurringRadio.label}
      component={renderSwitchComponent}
      isChecked={formValues.recurringEnabled === 'yes'}
    />
  );
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

RecurringSwitch.propTypes = {
  formValues: PropTypes.object,
};

export default connect(mapStateToProps)(RecurringSwitch);
